import { Form, FormInstance } from "antd";
import React from "react";
import { InputNumberStd } from "src/components/InputNumberStd";
import { edCompField } from "../ParamsEditorInfo2";
import {
  Accept,
  MaxCount,
  MaxSize,
  MultipleChoiceIteratorDepend,
} from "./common";

type Props = {
  form: FormInstance;
};
export const ImageCarouselEdProps: React.FC<Props> = ({ form }) => {
  const multiple = Form.useWatch(edCompField("multiple"));
  return (
    <>
      <MultipleChoiceIteratorDepend form={form} />
      {multiple && <MaxCount />}
      <MaxSize />
      <Accept />
      <Form.Item name={edCompField("imageHeight")} label="Высота изображения">
        <InputNumberStd min={1} addonAfter="px" />
      </Form.Item>
    </>
  );
};
